<form class="mc-spring-board" [formGroup]="newCommitForm" (ngSubmit)="onSubmit()">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    Create New Commit
    <span class="mc-fill-remaining-flex-space"></span>
    <button type="button" mat-icon-button tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"> </mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-form-body mc-d-flex mc-flex-column">
    <div class="mc-spring-board mc-min-height-0">
      <p class="mc-spring-board-header mc-form-section">
        Commit the {{ data.filePaths?.length | mcPluralize: 'file' }} below:
      </p>

      <div class="mc-spring-board-body mc-collab-commit-dialog-path-list-container">
        <mat-list class="mc-list-compact mc-form-section">
          <mat-list-item *ngFor="let filePath of data.filePaths">
            <mc-path-list-item [path]="filePath"></mc-path-list-item>
          </mat-list-item>
        </mat-list>
      </div>

      <div class="mc-spring-board-form-footer">
        <mc-workspace-files-user-status-list [licenseId]="data.licenseId" [workspaceFiles]="workspaceFiles$ | async" [workspaceFileUserStatus]="WorkspaceFileUserStatus.InProgress">
          <ng-template mcWorkspaceFilesUserStatusListWarning let-currentUserHasInProgressFiles="currentUserHasInProgressFiles" let-workspaceFileCount="workspaceFileCount">
            <ng-container *ngIf="workspaceFileCount === 1">
              Other users are editing this file.
            </ng-container>
            <ng-container *ngIf="workspaceFileCount > 1">
              Other users are editing one or more of these files.
            </ng-container>
            Committing now will include their changes.
            <ng-container *ngIf="currentUserHasInProgressFiles">
              Consider clicking 'Ready to Commit' to update your status instead.
            </ng-container>
          </ng-template>
        </mc-workspace-files-user-status-list>

        <mat-form-field appearance="standard" class="mc-form-field" color="secondary">
          <mat-label>Commit Message</mat-label>
          <textarea matInput class="mc-collab-commit-dialog-textarea" formControlName="commit" placeholder="Commit Message" required rows="3"></textarea>
          <mat-error>
            <mc-form-control-error-message [form]="newCommitForm" controlName="commit" type="mc_commit_message"></mc-form-control-error-message>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="closeDialog()">Cancel</button>
      <button type="submit" mat-raised-button color="primary">Commit</button>
    </div>
  </div>

  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</form>